import LoginPasswordAuth from "./login-password-auth.jsx"

export default {
    LoginPasswordAuth
}
